import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import { withRouter } from "react-router-dom";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminRoleList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
        const rolePermissions = this.context.rolePermissionsIndexed ? Object.values(this.context.rolePermissionsIndexed) : [];
        const userprofileRoles = this.context.userprofileRolesIndexed ? Object.values(this.context.userprofileRolesIndexed) : [];

        const permissionCountsByRoleId = rolePermissions.reduce((counts, rolePermission) => {
            const roleId = rolePermission.roleId;
            counts[roleId] = (counts[roleId] || 0) + 1;
            return counts;
        }, {});

        const userIdsByRoleId = userprofileRoles.reduce((userSetsByRoleId, userprofileRole) => {
            if (userprofileRole.deleted === true) {
                return userSetsByRoleId;
            }

            const roleId = userprofileRole.roleId;
            if (!userSetsByRoleId[roleId]) {
                userSetsByRoleId[roleId] = new Set();
            }

            userSetsByRoleId[roleId].add(userprofileRole.userProfileId);
            return userSetsByRoleId;
        }, {});

        const rows = Object.values(this.context.rolesIndexed).map((role) => {
            const permissionCount = permissionCountsByRoleId[role.id] ?? 0;
            const userCount = userIdsByRoleId[role.id] ? userIdsByRoleId[role.id].size : 0;
            return {
                ...role,
                userCount: userCount,
                permissionCount: permissionCount,
            };
        });

        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number" },
                    { key: "name", name: "Name", type: "string" },
                    { key: "defaultDashboardId", name: "Default Dashboard", type: "dashboard" },
                    { key: "userCount", name: "# Users", type: "number", width: 110 },
                    { key: "permissionCount", name: "# Permissions", type: "number", width: 130 },
                ]}
                sort={[
                    {
                        key: "name",
                        direction: "ascending",
                    },
                ]}
                rows={rows}
                onClick={(role) => {
                    this.props.history.push({
                        pathname: "/admin/role/" + role.id
                    });
                }}
            />
        );
    }
});
